var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1PeronalizedService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 19.45V61.8H44a4 4 0 00-4 4h-4a4 4 0 00-4-4H3V18h29.12a7.82 7.82 0 015.8 2.57l-3 2.69a3.81 3.81 0 00-2.8-1.26H7v36.2h25a7.78 7.78 0 014 .68v-8l4-2.94v11a7.78 7.78 0 014-.68l25-.1V22.33l4-2.88zM29 29H11v3h18v-3zm-3 9.81L59.7 7.09c1.82-1.6 5-.85 7.17 1.64 2.17 2.49 2.44 5.46.93 7.14L34.25 47.51l-12.13 2.87L26 38.81zm6.23-.08l2 2.18 29.92-27.78-2.05-2.19-29.87 27.79zm-5.53 6.08a1.8 1.8 0 011 .54c.189.206.335.447.43.71l3.5-1.22-3.43-3.57-1.5 3.54zM23 35H11v3h12v-3zm-12 9h8v-3h-8v3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Peronalized_service.e872d2ac.svg";
export { SvgK1PeronalizedService as ReactComponent };